import { createSelector } from '@ngrx/store';
import { AppState } from '../reducers';
import * as fromAggregateGraphHub from './aggregate-graph-hub.reducer';

export const selectReadmodelHub = (state: AppState) => state.aggregateGraphHub;

export const hubActivated = createSelector(
	selectReadmodelHub,
	(state: fromAggregateGraphHub.State) => state.activated
);